import type {LinkProps} from '@jetbrains/ring-ui/components/link/link'
import * as React from 'react'

import RouterLink from '../../../../../containers/EntityLink'
import {useIsSakuraSelected} from '../../../../../hooks/useIsSakuraSelected'
import useMyId from '../../../../../hooks/useMyId'
import {getIsSakuraUI} from '../../../../../selectors'
import {GUEST_ID} from '../../../../../types'
import Link from '../../../../common/Link/Link'
import type {LinkType} from '../../Header.consts'

import {useAppSelector} from 'src/hooks/react-redux'

type OwnProps = {
  to: LinkType
  children: LinkProps['children']
  className?: string
  innerClassName?: string
  title?: string
  active?: boolean
}
const temporaryClassicUISessionKey = 'isTemporaryClassicUISession'

function LinkHost({to, children, ...props}: OwnProps) {
  const userId = useMyId()
  const isSakuraSelected = useIsSakuraSelected()
  const isSakuraUI = useAppSelector(getIsSakuraUI)
  const isGuest = userId === GUEST_ID
  const link = React.useMemo(() => {
    if (to.sakura == null) {
      return {
        to: to.classic,
        sakura: false,
      }
    }

    const isTemporaryClassicUISession =
      window.sessionStorage.getItem(temporaryClassicUISessionKey) === 'true'

    if (isGuest) {
      if (isTemporaryClassicUISession) {
        return {
          to: to.classic,
          sakura: false,
        }
      }

      if (isSakuraUI) {
        return {
          to: to.sakura,
          sakura: true,
        }
      }
    }

    return {
      to: isSakuraSelected && !isTemporaryClassicUISession ? to.sakura : to.classic,
      sakura: isSakuraSelected,
    }
  }, [isSakuraUI, isGuest, isSakuraSelected, to])

  if (link.to == null) {
    return null
  }

  return isSakuraUI && link.sakura ? (
    <RouterLink data-selected={props.active} to={link.to} {...props}>
      {children}
    </RouterLink>
  ) : (
    <Link supressConservative data-selected={props.active} href={link.to} {...props}>
      {children}
    </Link>
  )
}

export default React.memo(LinkHost)
